import Title from 'antd/es/typography/Title';

export const Dashboard = () => {
  return <Title>Dashboard in progress</Title>;
};
